import React from "react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

const STATUS_CONFIG = {
  Scheduled:       { label: "À l'heure",             bg: "bg-blue-50",   text: "text-blue-700",   border: "border-blue-200",   dot: "bg-blue-500"    },
  Delayed:         { label: "Retardé",                bg: "bg-amber-50",  text: "text-amber-700",  border: "border-amber-200",  dot: "bg-amber-500"   },
  Boarding:        { label: "Embarquement",           bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200",dot: "bg-emerald-500", pulse: true },
  GateClosed:      { label: "Porte fermée",           bg: "bg-amber-50",  text: "text-amber-700",  border: "border-amber-200",  dot: "bg-amber-500",  pulse: true },
  Departed:        { label: "En vol",                 bg: "bg-stone-50",  text: "text-stone-600",  border: "border-stone-200",  dot: "bg-stone-400"   },
  EnRoute:         { label: "En vol",                 bg: "bg-stone-50",  text: "text-stone-600",  border: "border-stone-200",  dot: "bg-stone-400"   },
  ExpectedToArrive:{ label: "Atterrissage imminent",  bg: "bg-blue-50",   text: "text-blue-600",   border: "border-blue-200",   dot: "bg-blue-400"    },
  Landed:          { label: "Atterri",                bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200",dot: "bg-emerald-500" },
  Arrived:         { label: "Atterri",                bg: "bg-emerald-50",text: "text-emerald-700",border: "border-emerald-200",dot: "bg-emerald-500" },
  Cancelled:       { label: "Annulé",                 bg: "bg-red-50",    text: "text-red-700",    border: "border-red-200",    dot: "bg-red-500"     },
  Diverted:        { label: "Dérouté",                bg: "bg-red-50",    text: "text-red-700",    border: "border-red-200",    dot: "bg-red-500"     },
  Unknown:         { label: "Information indisponible",bg: "bg-stone-50", text: "text-stone-500",  border: "border-stone-200",  dot: "bg-stone-400"   },
};

export function FlightStatusBadge({ status, size = "md" }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.Unknown;
  const px = size === "lg" ? "px-3 py-1" : "px-2 py-0.5";
  const txt = size === "lg" ? "text-sm" : "text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1.5 border rounded-sm ${cfg.bg} ${cfg.text} ${cfg.border} ${px} ${txt}`}
      style={LORA}
      data-testid={`flight-status-badge-${status?.toLowerCase()}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot} ${cfg.pulse ? "animate-pulse" : ""}`} />
      {cfg.label}
    </span>
  );
}
